@if (show) {
  <div class="environment-banner" role="alert">
    For testing purposes only. Do not enter any personally identifiable or sensitive information.
  </div>
}
